"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Transition = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var Transition = exports.Transition = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var theme = (0, _material.useTheme)();
    var drawer = props.drawer, otherProps = _object_without_properties(props, [
        "drawer"
    ]);
    var isMobile = (0, _material.useMediaQuery)(theme.breakpoints.down('sm'));
    if (isMobile) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Slide, _object_spread({
            ref: ref,
            direction: "up"
        }, otherProps));
    }
    if (drawer) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Slide, _object_spread({
            ref: ref,
            direction: "left"
        }, otherProps));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Fade, _object_spread({
        ref: ref
    }, otherProps));
}); //# sourceMappingURL=Transition.js.map
